import { Navigate, useLocation } from "react-router-dom";
import { useJourneyAuth } from "../../auth/AuthContext";
import { canReadManual, loginPath, MANUAL_ROLES } from "../../auth/session";
import { getManual } from "../../manuals";
import { withFilmQuery } from "@tour/film.js";

export default function RequireManual({ role, children }) {
  const { session } = useJourneyAuth();
  const { search } = useLocation();
  if (!MANUAL_ROLES.includes(role) || !getManual(role)) {
    return <Navigate to={withFilmQuery("/", search)} replace />;
  }
  if (!session) return <Navigate to={withFilmQuery(loginPath(role), search)} replace />;
  if (!canReadManual(session, role)) {
    if (MANUAL_ROLES.includes(session.role)) {
      return <Navigate to={withFilmQuery(`/manuals/${session.role}`, search)} replace />;
    }
    return <Navigate to={withFilmQuery("/manuals", search)} replace />;
  }
  return children;
}
